/*
 * Copyright (c) 2017 Payoneer Germany GmbH. All rights reserved.
 */

var ajaxAdapter = require('./util/ajax-adapter');
var toObjectMiddleware = require('./util/to-object-adapter');

/**
 * Performs a localization request
 *
 * @param url The URL for the localization request
 * @param callback function to be called after response arrived
 * @param bindingData data transferred to callback
 */
function load(url, callback, bindingData) {
    var system = {
        type: 'GET',
        url: url,
    };
    ajaxAdapter(system)
        .fail(function (err) {
            err.request = system;
            callback(err, null, bindingData);
        })
        .done(function (data) {
            callback(null, toObjectMiddleware(data), bindingData);
        });
}

function translate(key, translationObj) {
    return translationObj[key] === undefined ? '' : translationObj[key];
}

module.exports = {
    load: load,
    translate: translate,
};
